import { FormFieldAutocomplete } from 'global/components/Form'
import { CalendarClockIcon } from 'lucide-react'
import type { CondicaoUi } from './condicao-ui'

/** Só :15 e :45 — os únicos minutos em que o agendador das rotinas roda. */
const OPCOES_HORARIO = Array.from({ length: 24 }, (_, hora) =>
    ['15', '45'].map(minuto => `${String(hora).padStart(2, '0')}:${minuto}`),
).flat()

function ParametrosAgendado() {
    return (
        <FormFieldAutocomplete
            name="parametros.horario"
            label="Horário"
            options={OPCOES_HORARIO}
            required
        />
    )
}

export const agendado: CondicaoUi = {
    icone: CalendarClockIcon,
    parametrosIniciais: { horario: '06:15' },
    Parametros: ParametrosAgendado,
    resumir: parametros => `Todos os dias às ${parametros.horario}`,
}
